(function() {
  var arrUtil, knockoutUtil, numUtil,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  numUtil = require('resources/assets/coffee/Core/utils/number');

  arrUtil = require('resources/assets/coffee/Core/utils/array');

  knockoutUtil = exports;

  knockoutUtil.constrainValues = function(lower, higher, increment, allow_equal) {
    if (increment == null) {
      increment = 1;
    }
    if (allow_equal == null) {
      allow_equal = true;
    }
    if (ko.isObservable(lower)) {
      lower.subscribe((function(_this) {
        return function(lower_val) {
          var higher_val, new_higher_val, new_lower_val;
          lower_val = parseInt(lower_val);
          if (numUtil.notSet(lower_val)) {
            return;
          }
          higher_val = ko.utils.unwrapObservable(higher);
          if (numUtil.notSet(higher_val) || lower_val > higher_val || (lower_val === higher_val && !allow_equal)) {
            if (ko.isObservable(higher) && !ko.isComputed(higher)) {
              if (allow_equal) {
                new_higher_val = lower_val;
              } else {
                new_higher_val = lower_val + increment;
              }
              return higher(new_higher_val);
            } else {
              if (allow_equal) {
                new_lower_val = higher_val;
              } else {
                new_lower_val = higher_val - increment;
              }
              return lower(new_lower_val);
            }
          }
        };
      })(this));
    }
    if (ko.isObservable(higher)) {
      return higher.subscribe((function(_this) {
        return function(higher_val) {
          var lower_val, new_higher_val, new_lower_val;
          higher_val = parseInt(higher_val);
          if (numUtil.notSet(higher_val)) {
            return;
          }
          lower_val = ko.utils.unwrapObservable(lower);
          if (numUtil.notSet(lower_val) || higher_val < lower_val || (higher_val === lower_val && !allow_equal)) {
            if (ko.isObservable(lower) && !ko.isComputed(lower)) {
              if (allow_equal) {
                new_lower_val = higher_val;
              } else {
                new_lower_val = higher_val - increment;
              }
              return lower(new_lower_val);
            } else {
              if (allow_equal) {
                new_higher_val = lower_val;
              } else {
                new_higher_val = lower_val + increment;
              }
              return higher(new_higher_val);
            }
          }
        };
      })(this));
    }
  };

  knockoutUtil.constrainToRange = function(observable, range) {
    observable.subscribe((function(_this) {
      return function(val) {
        var closest, range_arr;
        val = parseInt(val);
        if (numUtil.notSet(val)) {
          return;
        }
        range_arr = ko.utils.unwrapObservable(range);
        if (range_arr.length && indexOf.call(range_arr, val) < 0) {
          closest = arrUtil.closest(range_arr, val);
          if (closest != null) {
            return observable(closest);
          }
        }
      };
    })(this));
    if (ko.isObservable(range)) {
      return range.subscribe((function(_this) {
        return function() {
          return observable(observable());
        };
      })(this));
    }
  };

  knockoutUtil.linkValues = function(lower, higher, offset) {
    if (offset == null) {
      offset = 1;
    }
    lower.subscribe((function(_this) {
      return function(lower_val) {
        var higher_val;
        lower_val = parseInt(lower_val);
        if (numUtil.notSet(lower_val)) {
          return;
        }
        higher_val = parseInt(higher());
        if (higher_val !== lower_val + offset) {
          return higher(lower_val + offset);
        }
      };
    })(this));
    return higher.subscribe((function(_this) {
      return function(higher_val) {
        var lower_val;
        higher_val = parseInt(higher_val);
        if (numUtil.notSet(higher_val)) {
          return;
        }
        lower_val = parseInt(lower());
        if (lower_val !== higher_val - offset) {
          return lower(higher_val - offset);
        }
      };
    })(this));
  };

}).call(this);
